export default __webpack_public_path__ + "static/media/h5-section2-bg3.5acc1282.png";